import { Observer, observer } from "mobx-react-lite";
import {
  Row,
  Col,
  Select,
  Divider,
  InputNumber,
  Input,
  Space,
  Button,
  Modal,
  Image,
  Table,
  Popconfirm,
  Tooltip,
  ColorPicker
} from "antd";
import { SwitchBlock } from '../../../../components/SwitchBlock'
import i from '../../../../translations/i'
import { __product } from '../__product'
import { runInAction } from 'mobx'
import React, { useEffect } from 'react'
import __select from "../../../../helpers/select_entity/__select.controller";
import { toJS } from "mobx"
import {
  SelectCategories,
  SelectEntity,
  SelectProducts,
  SelectStatus
} from "../../../../helpers/select_entity/SelectEntity";
import { CloseOutlined, DeleteOutlined, EyeOutlined, SettingOutlined } from "@ant-design/icons";

export const ProductLinksToProducts = observer(() => {

  useEffect(() => {
    __product.setSets()
  }, [])

  return(
    <>
      <Row gutter={[20, 20]} align="bottom">
        <Col span={24}>
          <Row gutter={[20, 20]}>
            <Col span={24}>
              <Space size="large">
                <Button
                  type="primary"
                  onClick={() => __product.modalSetsOpened = true}
                >{i.t('def:Add products')}</Button>
              </Space>
            </Col>
            <Divider />
            <Col span={24}>
              <h3>{i.t('product:linkedProductsHeading')}</h3>
            </Col>
            <Col span={24}>
              <ListModule />
            </Col>
          </Row>
        </Col>

      </Row>


      <Modal
        open={__product.modalSetsOpened}
        footer={null}
        onCancel={() => __product.modalSetsOpened = false}
        width={1000}
        centered={true}
        maskClosable={false}
        className="cpl__modal"
      >
        <Button
          type="primary"
          onClick={() => __product.saveRel()}
          className="cpl__modal-close"
        >{i.t('def:actions.save')}</Button>

        <SelectProducts
          elementID={__select.select.value_array}
          returnFunction={(e: any) => __product.item.product_relations.push({ product_id: e.id, values_categories: e.values_categories ?? [] })}
          visible={false}
        />
      </Modal>
    </>
  )
})

const ListModule = observer(() => {

  useEffect(() => {
    console.log('ListModule')
  }, [])

  const columns = [
    {
      title: "ID",
      dataIndex: 'product_id',
      key: 'product_id'
    },
    {
      title: i.t('def:actions.actions'),
      key: 'action',
      render: (record: any) => (
        <Space>
          <Tooltip title={i.t('def:actions.remove')} zIndex={5}>
            <Popconfirm
              title={i.t('def:confirms.delete')}
              onConfirm={() => __product.deleteRelation(record.product_id)}
              okText={i.t('def:yes')}
              cancelText={i.t('def:no')}
            >
              <Button
                type="dashed"
                shape="circle"
                icon={<DeleteOutlined />}
                danger
              />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
    {
      title: i.t('def:image.image'),
      dataIndex: 'product',
      key: 'image',
      render: (e: any) => (e && e.image && e.image.path) ? <Image src={e.image.path} width={'80px'} /> : <></>
    },
    {
      title: i.t('def:name'),
      dataIndex: 'product',
      key: 'name',
      render: (e: any) => (e) ? e.name : ''
    },
    {
      title: i.t('product:showCharacteristics'),
      dataIndex: 'values_categories_select',
      key: 'values_categories_select',
      render: (e: any, record: any) => (
        <Select
          mode="multiple"
          style={{ width: '100%' }}
          options={(e && Array.isArray(e)) ? e.map((category: any) => ({
            label: category.name,
            value: category.id
          })) : []}
          value={record.lists ? record.lists.map((list_element: any) => list_element.category_id) : []}
          onChange={(category_element) => __product.changeRelationLists(record.id, category_element)}
          onClear={() => __product.changeRelationLists(record.id, [])}
        />
      )
    },
  ]

  return <Table
    rowKey="product_id"
    columns={columns}
    dataSource={toJS(__product.item.product_relations)}
  />
})